import React from "react";
import { Game } from "../containers/Game";

const App = () => {
  return <Game />;
};

export default App;
